module.exports = __webpack_public_path__ + "img/SIO_YouAreTheDJ_new.5b962a26.png";